/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSocialLikeResponse
 */
export interface EarnSocialLikeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EarnSocialLikeResponse
     */
    claimed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EarnSocialLikeResponse
     */
    alreadyClaimed: boolean;
    /**
     * 
     * @type {string}
     * @memberof EarnSocialLikeResponse
     */
    platform?: string;
    /**
     * The member's per-period cap was already full; nothing was claimed or credited.
     * @type {boolean}
     * @memberof EarnSocialLikeResponse
     */
    capReached?: boolean;
}

/**
 * Check if a given object implements the EarnSocialLikeResponse interface.
 */
export function instanceOfEarnSocialLikeResponse(value: object): value is EarnSocialLikeResponse {
    if (!('claimed' in value) || value['claimed'] === undefined) return false;
    if (!('alreadyClaimed' in value) || value['alreadyClaimed'] === undefined) return false;
    return true;
}

export function EarnSocialLikeResponseFromJSON(json: any): EarnSocialLikeResponse {
    return EarnSocialLikeResponseFromJSONTyped(json, false);
}

export function EarnSocialLikeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSocialLikeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimed': json['claimed'],
        'alreadyClaimed': json['alreadyClaimed'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'capReached': json['capReached'] == null ? undefined : json['capReached'],
    };
}

export function EarnSocialLikeResponseToJSON(json: any): EarnSocialLikeResponse {
    return EarnSocialLikeResponseToJSONTyped(json, false);
}

export function EarnSocialLikeResponseToJSONTyped(value?: EarnSocialLikeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimed': value['claimed'],
        'alreadyClaimed': value['alreadyClaimed'],
        'platform': value['platform'],
        'capReached': value['capReached'],
    };
}

